import React, { useState, useEffect } from 'react';
import VoiceChordJson from './voice-chord.json';
import SelectBoxItems from './select-box.json';
import { Icon, IconClose } from '../../../base/icons';
// css for voice chord
import './voice-chord.css';
import { useDispatch, useSelector } from 'react-redux';
import { getChordImages, getChordsData } from '../../welcome-dashboard/Request.d';
import { FEATURE_CUSTOM_REDUX_V2 } from '../../constant';
import { CURRENT_ROOM_LOCATION, Constant } from '../../../webjam/constant';
import { setToolsObject } from '../../redux/tool-webjam-v2/actions';
import toast from 'react-simple-toasts';
import { getLJsonStorage, usePrevious } from '../../welcome-dashboard/Utils';
import { ct } from '../../constant-Utils';

const VoiceChord = (props) => {

	const { socket, Sessions, closeTool, toolDetail } = props;

	let { toolOpenLocal } = props;

	const [state, setState] = useState({
		selectKeysA: 'Please Select',
		selectKeysE: 'Please Select',
	});
	const [voichData, setvoicheData] = useState([])

	// hide buttons and cross buttons
	const [isDisable, setIsDisable] = useState(false);
	const [imgHtml, setImgHtml] = useState([]);
	const [box1Data, setbox1Data] = useState([])
	const [box2Data, setbox2Data] = useState([]);
	const dispatch = useDispatch();
	const { chordData } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V2]);
	const { openByUser, SessionId } = Sessions;
	const [showKeysE, setShowKeysE] = useState(false);
	const [showButtons, setShowButtons] = useState(0);

	const [isLocalUser, setIsLocalUser] = useState(false);

	useEffect(() => {
		if (Object.keys(chordData).length === 0 && chordData.constructor === Object) {
			dispatch(getChordsData())
		}
		let allBox1Arr = [];
		//set first box array and value by default
		Object.keys(chordData).forEach(function (key) {
			allBox1Arr.push(key);
		});
		setbox1Data(allBox1Arr)
		let chordDataKeyy = []
		if (Object.keys(chordData).length !== 0) {
			chordDataKeyy = Object.values(chordData['A']);
		}
		setbox2Data(chordDataKeyy)
		setState({
			...state,
			selectKeysA: toolDetail ? toolDetail?.selectKeysA : 'Please Select',
			selectKeysE: toolDetail ? toolDetail?.selectKeysE : 'Please Select'
		})
	}, [chordData]);


	useEffect(() => {
		if (Object.keys(toolDetail).length !== 0) {
			let toolChord = toolDetail;
			if (toolDetail?.isSocket == true) {
				let chordDataKeyy = []
				if (Object.keys(chordData).length !== 0) {
					chordDataKeyy = Object.values(chordData[toolChord?.selectKeysA]);
				}
				setbox2Data(chordDataKeyy);
				let count = 1;
				if (count == 1) {
					setShowButtons(showButtons + 1);
					count++;
				}
				setState({
					...state,
					selectKeysA: toolChord?.selectKeysA,
					selectKeysE: toolChord?.selectKeysE
				})
				showChordsData({ isSocket: true, ...toolChord });
			}
		}
	}, [toolDetail, chordData])

	useEffect(() => {
		if (props.toolOpenLocal) {
			setIsLocalUser(true)
		}
	}, [])

	useEffect(
		() => {
			if (SessionId === openByUser) {
				setIsDisable(true);
				if (showButtons) {
					setIsDisable(false);
				}
			}
		},
		[imgHtml, openByUser]
	);

	useEffect(() => {
		if (Object.keys(chordData)?.length !== 0) {
			socket.on("broadcast_chord_data", (data) => {
				const { room, voiceChordData } = data;
				// setvoicheData(voiceChordData.box2Data)
				if (room == CURRENT_ROOM_LOCATION) {
					const chordDataKey = Object.values(chordData[voiceChordData?.selectKeysA]);
					setbox2Data(chordDataKey)
					setState({
						selectKeysA: voiceChordData?.selectKeysA,
						selectKeysE: voiceChordData?.selectKeysE
					});
					// Show the image
					showChordsData({ isSocket: true, ...voiceChordData });
				}
			});
		}

		return function cleanup() {
			// unsubscribe the listener
			socket.off('broadcast_chord_data');
		}
	}, [chordData])

	function sleep(time) {
		return new Promise((resolve) => setTimeout(resolve, time));
	}

	const showChordsData = (data) => {

		// all chords Images
		let { selectKeysA, selectKeysE } = state;
		const { isSocket } = data;
		// student can able to send to techer
		//receiver if generator else
		if (isSocket) {
			console.log("case 1", data)
			setShowKeysE(true)
		} else {
			if (selectKeysA !== 'Please Select' || selectKeysA !== 'Please Select') {
				console.log("case 2", data)
				// emit data for all user

				if (data?.isLocal) {
					socket.emit("openTools_fromtool", {
						openTool: 'voice-chord',
						SessionId: Sessions.openByUser,
						location: CURRENT_ROOM_LOCATION
					});
				}
				// Sleep for one second
				sleep(1000).then(() => {
					// Sending the cord data
					socket.emit('send_chord_data', {
						room: CURRENT_ROOM_LOCATION,
						voiceChordData: {
							selectKeysA,
							selectKeysE,
						},
					});
				});

				if (props.openToolStatus) {
					props.openToolStatus({
						selectKeysA,
						selectKeysE
					})
				}

				let chordObj = {
					selectKeysA,
					selectKeysE,
				}
				dispatch(setToolsObject(chordObj));
			} else {
				toast(ct("Translate.messages.selectValues"), Constant.App.ToastTime.LongCloseTime)
			}
		}
		const data2 = { "parentChord": data?.selectKeysA ? data?.selectKeysA : selectKeysA, "chirldChord": data?.selectKeysE ? data?.selectKeysE : selectKeysE }
		dispatch(getChordImages(data2)).then((reee) => {
			setImgHtml(reee);
		})
	}

	const keysEChange = (e, changeType) => {
		// setting the values of fields
		const value = e.target.value;
		const keyy = e.target.id;
		if (changeType) {
			const chordDataKey = Object.values(chordData[value]);
			setbox2Data(chordDataKey)
			setState({
				...state,
				[keyy]: value,
				selectKeysE: changeType
			});
		} else {
			if (keyy === "selectKeysA") {
				const chordDataKey = Object.values(chordData[value]);
				setbox2Data(chordDataKey)
				setState({
					...state,
					[keyy]: value,
					selectKeysE: chordDataKey[0]
				});
				setShowKeysE(true)
			} else {
				setState({
					...state,
					[keyy]: value
				});
			}
		}
	}

	const isGuestAccount = getLJsonStorage("auth", "guest_id");

	return (
		<div id="showchord_container" className="metrono-outer" style={{ minHeight: "300px" }}>
			{isGuestAccount ? "" : <div
				className='close-side-bar'
				id='showChord-close-icon-wrapper'
				onClick={closeTool}>
				<Icon containerId='showChord-close-icon' src={IconClose} />
			</div>}
			<div id="transparentdidfirst">
				<div id="wrapper1" style={{ position: "relative", zIndex: 1 }}
				>
					<center>
						<label>{ct("rta-trmc.tools.chord")}</label>
						<select id="selectKeysA" value={state?.selectKeysA} onChange={(e) => keysEChange(e)} >
							<option selected disabled>{ct("rta-trmc.tools.pleaseSelect")}</option>
							{box1Data?.map((item, index) => {
								return <option key={index} value={item}>{item}</option>
							})}
						</select>
						<label></label>
						<select id="selectKeysE" value={state?.selectKeysE} onChange={(e) => keysEChange(e)} >
							<option selected disabled>{ct("rta-trmc.tools.pleaseSelect")}</option>
							{showKeysE &&
								<>
									{box2Data?.map((item, index) => {
										let _item = item;
										let setItem;
										_item = _item.replaceAll(" ", "_");
										setItem = "rta-trmc.chordGenerator." + state.selectKeysA + "." + _item;
										return <option key={index}
											value={item}
										>{item}</option>
									})}
								</>
							}
						</select>
						<label></label>
						{/* {(isDisable || isLocalUser) && */}
						{isLocalUser &&
							<button id="openChrods" className="btn btn-primary" onClick={() => {
								showChordsData({ isSocket: false, isLocal: true })
							}} >{ct("rta-trmc.tools.generateChord")}</button>
						}
					</center>
					<div id="transparentdid" style={{ filter: "alpha(opacity = 0)", display: "block", zIndex: 2, background: "transparent" }}>
						{imgHtml?.length ?
							imgHtml?.map((item, i) => {
								// const src = `${Constant.App.ServerUrl}${item}`;
								return <img key={i} alt={item} src={`${Constant?.App?.ServerUrl}${item}`} />
							})
							: ct("rta-trmc.tools.selectAndGenerate")}
					</div>
				</div>
			</div>
		</div>
	);
}

export default VoiceChord;
